import React, { useEffect, useState } from "react";
import "./index.scss";

import { useNavigate } from "react-router-dom";

import ContactService from "../../../services/contact/contact.service";
import { showErrorToaster } from "../../../components/toaster/error";
import DataTableDisplay from "../../../components/tableMission";

const contactService = new ContactService();

function ContactListe() {
  const [contacts, setContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const loadData = async () => {
    setIsLoading(true);
    try {
      const res = await contactService.getAllContact();
      setContacts(res?.data || []);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const columnsContacts = [
    {
      name: "Nom complet",
      selector: (row) => (
        <div className="table-text capitalize">{row?.fullname}</div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => <div className="table-text">{row?.email}</div>,
      sortable: true,
    },

    {
      name: "Sujet",
      selector: (row) => <div className="table-text">{row?.subject}</div>,
      hide: "md",
      sortable: true,
    },
    {
      name: "Message",
      selector: (row) => <div className="table-text">{row?.message}</div>,
      hide: "md",
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => (
        <div className="table-text">
          {row?.createdAt ? new Date(row.createdAt).toLocaleDateString() : ""}
        </div>
      ),
      hide: "md",
      sortable: true,
    },
  ];

  return (
    <section className="usersPage">
      <div className="container-fluid">
        <div className="row my-0 my-md-5 align-items-center">
          <div className="col-sm text-center text-sm-start">
            <h3>Liste des contacts</h3>
          </div>
        </div>

        {isLoading ? (
          <div className="d-flex my-5 justify-content-center align-items-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Chargement...</span>
            </div>
          </div>
        ) : (
          <div className="my-5 py-2">
            <DataTableDisplay columns={columnsContacts} data={contacts} />
          </div>
        )}
      </div>
    </section>
  );
}

export default ContactListe;
